import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import OptionalsIcon from '@material-ui/icons/Settings';
import SaveIcon from '@material-ui/icons/Save';
import SearchIcon from '@material-ui/icons/Search';
import CheckIcon from '@material-ui/icons/Check';
import OptionalsAPI from '../../../API/OptionalsAPI';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import ConfirmationDialog from '../../Utils/ConfirmationDialog';
import LinearProgress from '../../Utils/LinearProgress';
import green from '@material-ui/core/colors/green';
import { handleServerError, handleSpecialCharacters } from '../../../Utils/Helper';
import { FP_GROUP, FP_PHASE } from '../../../Utils/Constants';


const styles = theme => ({
  marginHeadOptionals: {
    margin: 0
  },
  marginSelectOptionals: {
    margin: '12px 0px 8px 0px'
  },
  toolbarRoot: {
    display: 'flex',
    position: 'relative',
    backgroundColor: '#00B1AF',
    padding: '0px 12px'
  },
  titleHead: {
    color: '#ffffff'
  },
  searchField: {
    width: '400px',
    margin: '4px 0px 8px 0px'
  },
  searchIconMargin: {
    marginRight: '4px'
  },
  dividerHead: {
    borderBottom: '2px solid #007b7a'
  },
  checboxSize: {
    width: '32px',
    height: '32px'
  },
  button: {
    margin: theme.spacing.unit
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  buttonSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600],
    },
  },
  fabProgress: {
    margin: theme.spacing.unit,
    position: 'absolute',
    right: 18,
    top: 0,
    zIndex: 1
  }
});


class CarOptionals extends React.Component {
  searchTimer = null;

  constructor(props) {
    super(props);
    this.state = {
      openOptionals: false,
      scroll: 'paper',
      loadingOptionals: false,
      successOptionals: false,
      optionalsData: [],
      openError: false,
      alertMessage: '',
      searchOptionalsBy: '',
      reloading: false,
      announcedOptionals: [],
      negotiatedOptionals: [],
      openDialog: false,
      confirmationQuestion: '',
      confirmationMessage: '',
      confirmationFunction: () => { },
      cancelFunction: () => { },
      noFunction: () => { },
      yesFunction: () => { },
      isToAskChangeReservations: false,
      changedValueDetected: false,
      openDialogForced: false
    };
  }

  handleClickOpen = scroll => () => {
    const optionalsDataAPI = new OptionalsAPI();
    this.setState({ reloading: true });
    optionalsDataAPI.getOptionalsByL4Id(this.props.carId).then((response) => {
      let announcedOptionalsIds = [];
      response.data.forEach(item => {
        if (item.Announced)
          announcedOptionalsIds.push(item.OptionalID);
      });
      this.setState({
        optionalsData: this.orderAllOptionalsByAnnounced(this.props.optionalsData, announcedOptionalsIds),
        announcedOptionals: announcedOptionalsIds,
        negotiatedOptionals: response.data,
        reloading: false,
        openOptionals: true,
        scroll
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleCloseOptionals = (announcedOptionalsIds) => {
    this.setState({
      searchOptionalsBy: '',
      openOptionals: false,
      changedValueDetected: false
    });
    this.handleCloseDialog(announcedOptionalsIds);
  };

  handleCloseDialog = (announcedOptionalsIds) => {
    this.setState({ openDialog: false });
    if (Array.isArray(announcedOptionalsIds)) {
      let aUpdatedOptionalsDescriptions = [];
      this.props.optionalsData.forEach((oOptional) => {
        if (announcedOptionalsIds.indexOf(oOptional.value) > -1)
          aUpdatedOptionalsDescriptions.push(oOptional.label);
      });
      this.props.refreshOptionalsGrid(aUpdatedOptionalsDescriptions);
    }
  };

  handleCloseDialogForced = () => {
    this.setState({ openDialogForced: false });
  };

  handleGoBack = () => {
    if (this.state.changedValueDetected === true) {
      this.setState({
        openDialog: true,
        confirmationQuestion: 'Tem a certeza que pretende RETROCEDER sem guardar as alterações?',
        confirmationMessage: 'A informação relativamente às alterações executadas será perdida.',
        confirmationFunction: this.handleCloseOptionals,
        cancelFunction: this.handleCloseDialog
      });
    }
    else {
      this.handleCloseOptionals();
    }
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleCheckboxChange = (optionalId) => event => {
    let announcedOptionalIds = this.state.announcedOptionals;
    if (event.target.checked === true) {
      announcedOptionalIds.push(optionalId);
      this.setState({
        announcedOptionals: announcedOptionalIds
      });
    }
    else {
      for (var i = 0; i < announcedOptionalIds.length; i++) {
        if (announcedOptionalIds[i] === optionalId) {
          announcedOptionalIds.splice(i, 1);
        }
      }
      this.setState({
        announcedOptionals: announcedOptionalIds
      });
    }
    this.detectChange();
  };

  detectChange = () => {
    this.setState({ changedValueDetected: true });
  }

  handleConfirmForceSave = () => {
    this.setState({
      loadingOptionals: false,
      openDialog: false,
      openDialogForced: true,
      confirmationFunction: () => this.handleSubmitSaveOptionalsByL4(true, true),
      cancelFunction: this.handleCloseDialogForced
    });
  };

  handleSubmitSaveOptionalsByL4 = (ForceSave, BoolToChangeHash) => {
    const optionalsAPI = new OptionalsAPI();
    this.setState({ loadingOptionals: true, isToAskChangeReservations: false })
    let optDTO = { OptionalsIDs: this.state.announcedOptionals, ForceSave: ForceSave, isToChangeReservations: BoolToChangeHash }
    optionalsAPI.updateOptionalsByL4Id(this.props.carId, optDTO).then(() => {
      this.setState({
        loadingOptionals: false,
        successOptionals: true,
      });
      setTimeout(() => {
        this.setState({
          searchOptionalsBy: '',
          successOptionals: false
        });
        this.handleCloseOptionals(this.state.announcedOptionals);
        this.handleCloseDialogForced();
      }, 500);
    }).catch((error) => {
      let errorMessage = handleServerError(error);
      if (errorMessage.indexOf('cancelem as mesmas') > -1) {
        this.setState({
          confirmationQuestion: 'Tem a certeza que pretende MODIFICAR OS OPCIONAIS da viatura?',
          confirmationMessage: 'As viaturas da marca ' + this.props.negotiationLot.Brand + ' e modelo ' + this.props.negotiationLot.Model +
            ' possuem reservas associadas à totalidade de viaturas disponíveis. A modificação terá impacto sobre as reservas.'
        })
        this.handleConfirmForceSave();
      }
      else if (errorMessage.indexOf('modificar o hashcode da Reserva') > -1) {
        this.setState({
          confirmationQuestion: 'Tem a certeza que pretende MODIFICAR OS OPCIONAIS da viatura?',
          confirmationMessage: 'As viaturas da marca ' + this.props.negotiationLot.Brand + ' e modelo ' + this.props.negotiationLot.Model +
            ' possuem reservas associadas à totalidade de viaturas disponíveis.' + errorMessage,
          noFunction: () => this.handleSubmitSaveOptionalsByL4(true, false),
          yesFunction: () => this.handleSubmitSaveOptionalsByL4(true, true),
          isToAskChangeReservations: true
        })
        this.handleConfirmForceSave();
      }
      else {
        this.setState({
          loadingOptionals: false,
          successOptionals: false,
          openError: true,
          alertMessage: handleServerError(error)
        });
        this.handleCloseDialog();
        this.handleCloseDialogForced();
      }
    });
  };

  handleSearch = event => {
    this.setState({ searchOptionalsBy: handleSpecialCharacters(event.target.value) });
    this.reloadOptionalsBySearch();
  };

  reloadOptionalsBySearch() {
    const optionalsDataAPI = new OptionalsAPI();
    this.setState({ reloading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      optionalsDataAPI.getAllOptionals(this.state.searchOptionalsBy).then((response) => {
        this.setState({
          optionalsData: this.orderAllOptionalsByAnnounced(response.data, this.state.announcedOptionals),
          reloading: false,
          openOptionals: true
        });
      }).catch((error) => {
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      });
    }, 1500);
  };

  orderAllOptionalsByAnnounced = (allData, announcedIds) => {
    let orderedOptionals = [[], []];
    (allData || []).forEach(item => {
      if (announcedIds && announcedIds.indexOf(item.value) !== -1) {
        orderedOptionals[0].push(item);
      } else {
        orderedOptionals[1].push(item);
      }
    });

    return [...orderedOptionals[0], ...orderedOptionals[1]];
  }

  renderNegOptionals(negotiatedOptionals) {
    const { classes } = this.props;

    return negotiatedOptionals.map(negOptionalItem => {
      if (negOptionalItem.Negotiated === true) {
        return (
          <Grid item xs={12} sm={12} key={negOptionalItem.OptionalID}>
            <FormControlLabel
              control={
                <Checkbox
                  color='secondary'
                  className={classes.checboxSize}
                  checked={negOptionalItem.OptionalID !== -1}
                  value={negOptionalItem.OptionalID}
                  disableRipple
                  inputprops={{ readOnly: true }}
                />}
              label={negOptionalItem.OptionalDescription}
            />
          </Grid>
        );
      }
      else
        return null;
    });
  };

  renderAnnouncedOptionals(allOptionals) {
    const { classes } = this.props;

    return allOptionals.map(optionalItem => {
      return (
        <Grid item xs={12} sm={12} key={optionalItem.value}>
          <FormControlLabel
            control={
              <Checkbox
                color='primary'
                className={classes.checboxSize}
                checked={this.state.announcedOptionals.indexOf(optionalItem.value) !== -1}
                value={optionalItem.value}
                onChange={this.props.estadoLotId !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0 ? null : this.handleCheckboxChange(optionalItem.value)}
                disableRipple={this.props.estadoLotId !== FP_PHASE || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0}
              />}
            label={optionalItem.label}
          />
        </Grid>
      );
    });
  };


  render() {
    const { classes } = this.props;
    const { loadingOptionals, successOptionals, reloading, optionalsData, negotiatedOptionals } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: successOptionals });

    return (
      <span>

        <Tooltip title='Alterar Opcionais' placement='bottom' >
          <Button variant='fab' color='primary' onClick={this.handleClickOpen('paper')} className={classNames(classes.button, classes.buttonSize)}>
            <OptionalsIcon />
          </Button>
        </Tooltip>

        <Dialog
          fullWidth
          maxWidth='md'
          open={this.state.openOptionals}
          onClose={this.handleCloseOptionals}
          scroll={this.state.scroll}
        >
          <Paper>
            <Toolbar className={classes.toolbarRoot}>
              <Typography variant='title' id='announcedOptionals' className={classes.titleHead} >
                OPCIONAIS ANUNCIADOS
              </Typography>
            </Toolbar>
          </Paper>

          <DialogContent>
            <Grid container>

              <Grid container spacing={24} className={classes.marginHeadOptionals}>
                <Grid item xs={12} sm={6}>
                  <Grid container justify='center' className={classes.dividerHead}>
                    <Typography variant='body2' id='selectNegotiatedOptionals'>
                      OPCIONAIS NEGOCIADOS
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Grid container justify='center' className={classes.dividerHead}>
                    <Typography variant='body2' id='selectAnnouncedOptionals'>
                      OPCIONAIS ANUNCIADOS
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid container>

                <Grid item xs={12} sm={12}>
                  {reloading && <LinearProgress />}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant='subheading' id='selectAnnouncedOptionals' className={classes.marginSelectOptionals}>
                    Selecionar opcionais:
                  </Typography>
                  {this.renderNegOptionals(negotiatedOptionals)}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id='searchOptionals'
                    label=''
                    placeholder='Pesquisar'
                    type='search'
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position='start' className={classes.searchIconMargin}>
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    className={classes.searchField}
                    value={this.state.searchOptionalsBy}
                    onChange={this.handleSearch}
                  />
                  {this.renderAnnouncedOptionals(optionalsData)}
                </Grid>
              </Grid>

            </Grid>
          </DialogContent>

          <Divider />
          <DialogActions disableActionSpacing>
            <Toolbar>
              <Tooltip title='Cancelar' placement='bottom' >
                <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleGoBack}>
                  <CloseIcon />
                </Button>
              </Tooltip>

              <Tooltip title='Guardar' placement='bottom' >
                <Button disabled={this.props.estadoLotId !== FP_PHASE || loadingOptionals || this.props.user.UserRoleType.indexOf(FP_GROUP) < 0} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={() => this.handleSubmitSaveOptionalsByL4(false)}>
                  {successOptionals ? <CheckIcon /> : <SaveIcon />}
                </Button>
              </Tooltip>
              {loadingOptionals && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
            </Toolbar>
          </DialogActions>

        </Dialog>

        <Dialog
          open={this.state.openDialog}
          onClose={this.handleCloseDialog}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialog}
            handleClose={this.handleCloseDialog.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            loading={this.state.loadingOptionals}
            success={this.state.successOptionals}
          />
        </Dialog>

        <Dialog
          open={this.state.openDialogForced}
          onClose={this.handleCloseDialogForced}
        >
          <ConfirmationDialog
            openConfirmationDialog={this.state.openDialogForced}
            handleClose={this.handleCloseDialogForced.bind(this)}
            confirmationQuestion={this.state.confirmationQuestion}
            confirmationMessage={this.state.confirmationMessage}
            confirmationFunction={this.state.confirmationFunction.bind(this)}
            cancelFunction={this.state.cancelFunction.bind(this)}
            noFunction={this.state.noFunction.bind(this)}
            yesFunction={this.state.yesFunction.bind(this)}
            isToAskChangeReservations={this.state.isToAskChangeReservations}
            loading={this.state.loadingOptionals}
            success={this.state.successOptionals}
          />
        </Dialog>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </span>
    );
  }
}

CarOptionals.propTypes = {
  classes: PropTypes.object.isRequired,
  refreshOptionalsGrid: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(CarOptionals));


// WEBPACK FOOTER //
// ./src/components/FirmPurchases/CarsList/CarOptionals.js